import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { createURL } from '@sm/utils';

import EndpageHeader from '~app/components/EndpageHeader';
import RebrandEpFormCore from '~app/components/RebrandEpFormCore';

import PerksIconWhite from '~static/images/icons/perks-icon-white.svg';
import MsgIconWhite from '~static/images/icons/msg-icon-white.svg';

const COPY = defineMessages({
  ENDPAGE_HEADER_COPY: {
    id: 'SurveyThanks.RebrandEpFormIntl.EndpageHeaderCopy',
    defaultMessage: 'Thank you for taking this survey.',
    description: '[Type: Header][Vis: med] - Informs the viewer that this survey has just completed',
  },

  PRODUCT_CALLOUT_PERKS_HEADING: {
    id: 'SurveyThanks.RebrandEpFormIntl.ProductCalloutPerksHeader',
    defaultMessage: 'Is your company missing key perks?',
    description:
      '[Type: Header][Vis: med] - Tagline to help entice users to views click the cta below. The CTA leads to another signup page with minimal information.',
  },
  PRODUCT_CALLOUT_PERKS_BODY: {
    id: 'SurveyThanks.RebrandEpFormIntl.ProductCalloutPerkseBody',
    defaultMessage:
      'People love their work perks. Send a survey to find out if you’re offering the incentives employees and potential candidates want.',
    description: '[Type: Paragraph][Vis: med] - Gives context to the above Tagline',
  },
  PRODUCT_CALLOUT_PERKS_CTA: {
    id: 'SurveyThanks.RebrandEpFormIntl.ProductCalloutPerksCTA',
    defaultMessage: 'FIND OUT',
    description: '[Type: Button][Vis: med] - The text for a button that leads users to another sign up page',
  },

  PRODUCT_CALLOUT_COLLABORATION_HEADING: {
    id: 'SurveyThanks.RebrandEpFormIntl.ProductCalloutCollaborationEUHeader',
    defaultMessage: 'Are your customers satisfied?',
    description: '[Type: Header][Vis: med] - Tag line to help user learn more about SurveyMonkey Collaboration',
  },
  PRODUCT_CALLOUT_COLLABORATION_BODY: {
    id: 'SurveyThanks.RebrandEpFormIntl.ProductCalloutCollaborationEUBody',
    defaultMessage: '83% of businesses who describe themselves as “successful” actively measure customer satisfaction.',
    description: '[Type: Paragraph][Vis: med] - Expands and reiterate the above header line.',
  },
  PRODUCT_CALLOUT_COLLABORATION_CTA: {
    id: 'SurveyThanks.RebrandEpFormIntl.ProductCalloutCollaborationEUCTA',
    defaultMessage: 'GET STARTED',
    description:
      "[Type: Button][Vis: med] - The button text which leads users to a marketing page to learn more about SurveyMonkey' premium plans",
  },
});

function RebrandEpFormIntl(): React.ReactElement {
  const utSource = 'survey_thanks';
  const utSource2 = 'rebrand_ep_form_intl';

  const CALLOUT_ITEM_SIGN_UP = {
    icon: PerksIconWhite,
    heading: t(COPY.PRODUCT_CALLOUT_PERKS_HEADING),
    copy: t(COPY.PRODUCT_CALLOUT_PERKS_BODY),
    href: createURL('/user/sign-up/', {
      ut_source: utSource,
      ut_source2: utSource2,
    }),
    cta: t(COPY.PRODUCT_CALLOUT_PERKS_CTA),
    ctaColor: 'sabaeus',
    name: 'perks',
  };

  const CALLOUT_ITEM_COLLABORATION = {
    icon: MsgIconWhite,
    heading: t(COPY.PRODUCT_CALLOUT_COLLABORATION_HEADING),
    copy: t(COPY.PRODUCT_CALLOUT_COLLABORATION_BODY),
    href: createURL('/mp/collaboration/', {
      ut_source: utSource,
      ut_source2: utSource2,
    }),
    cta: t(COPY.PRODUCT_CALLOUT_COLLABORATION_CTA),
    ctaColor: 'concord',
    name: 'collaboration',
  };

  return (
    <>
      <EndpageHeader copy={t(COPY.ENDPAGE_HEADER_COPY)} hasLogo headerColor="sabaeus" headerType="thanks" />
      <RebrandEpFormCore
        utSource={utSource}
        calloutItem1={CALLOUT_ITEM_SIGN_UP}
        calloutItem2={CALLOUT_ITEM_COLLABORATION}
      />
    </>
  );
}

export default RebrandEpFormIntl;
